import styled from '@emotion/styled';
import { mq } from './media';

export const StyledH1 = styled.h1`
  width: 100%;
  font-weight: 800;
  padding: 0.25rem 0 0.5rem;
  margin: 0 auto;
  font-size: 42px;
  color: var(--darkbg-content-color);
`;

export const StyledH2 = styled.h2`
  color: var(--darkbg-content-color);
  font-size: 42px;
  padding: 1rem 0;
  margin: 0 auto;
  max-width: 60ch;
  width: 100%;

  ${mq.lt.sm} {
    font-size: 32px;
  }
`;

export const StyledP = styled.p`
  font-size: 24px;
  color: var(--darkbg-content-color);
  max-width: 55ch;
  margin: 0 auto;
`;

export const StyledTag = styled.p`
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-weight: 800;
  margin: 0 auto;
  color: var(--bright-purple-color);
`;

//light headings

export const StyledH1Light = styled.h1`
  width: 100%;
  font-weight: 800;
  padding: 0.25rem 0 0.5rem;
  font-size: 42px;
  margin: 0 auto;
  color: var(--lightbg-content-color);
`;

export const StyledH2Light = styled.h2`
  color: var(--lightbg-content-color);
  font-size: 42px;
  padding: 1rem 0;
  max-width: 60ch;
  width: 100%;
  margin: 0 auto;

  ${mq.lt.sm} {
    font-size: 32px;
  }
`;

export const StyledTagLight = styled.p`
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  font-weight: 800;
  color: var(--bright-purple-color);
  margin: 0 auto;
`;

export const StyledPLight = styled.p`
  font-size: 24px;
  color: var(--lightbg-content-color);
  max-width: 55ch;
  margin: 0 auto;
`;
